import { Image } from "primereact/image";
import editImage from '../../assets/svg/Edit_Square.svg'
 
export default function EditButton() {
    return (
        <Image src={editImage} imageClassName="icon"  />
    
    )
}